export const EventGroupPurchaseTypes = { // eslint-disable-line import/prefer-default-export
  VOUCHER: 'voucher',
}



/** WEBPACK FOOTER **
 ** ./src/constants/eventgroup-constants.js
 **/